document.addEventListener('DOMContentLoaded', function() {
	let activeIndex = 0;
	const parent = document.querySelector('.galeria-karuzela-block');
	let updated = false;

	const updateCarousel = () => {
    const track = parent.querySelector('.gallery-track');
    const totalImages = parent.querySelectorAll('.gallery-image').length;

    // Determine images per page based on window width
    const imagesPerPage = window.innerWidth < 1024 ? 1.08 : 4;
    const maxIndex = Math.ceil(totalImages / imagesPerPage) - 1;

    // Prevent out-of-bound index
    if (activeIndex < 0) activeIndex = 0;
    if (activeIndex > maxIndex) activeIndex = maxIndex;

    // Move the gallery track smoothly
    if (track && track.style) {
        track.style.transform = `translateX(-${activeIndex * (100 / imagesPerPage)}%)`;
    }

		if (!updated) {
			// Update active dots
			const dotsContainer = parent.querySelector('.pagination-dots');
			const dots = dotsContainer.querySelectorAll('.dot');

			// Ensure there are enough dots for the current number of images
			if (dots.length !== maxIndex + 1) {
					// Clear existing dots
					dotsContainer.innerHTML = '';

					// Create new dots based on maxIndex
					for (let i = 0; i <= maxIndex; i++) {
							const dot = document.createElement('div');
							dot.classList.add('dot');
							dot.addEventListener('click', () => {
									activeIndex = i; // Update active index on dot click
									updateCarousel(); // Update the carousel
							});
							dotsContainer.appendChild(dot);
					}
				updated = true;
			}
		}
    // Update active dots
    const dots = parent.querySelectorAll('.dot');
    dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
    });
	};

	const handleDotClick = (index) => {
			activeIndex = index;
			updateCarousel();
	};

	const handleCarouselChange = (direction) => {
			activeIndex += direction;
			updateCarousel();
	};

	const openDialog = (imageUrl) => {
			const dialog = document.getElementById('gallery-dialog');
			const dialogImage = document.getElementById('dialog-image');
			if (!dialog || !dialogImage) return;

			dialogImage.src = imageUrl; // Set the image in the dialog
			dialog.style.display = 'flex'; // Show the dialog
	};

	const closeDialog = () => {
			const dialog = document.getElementById('gallery-dialog');
			dialog.style.display = 'none'; // Hide the dialog
	};

	const attachEvents = () => {
			// Attach event listeners for carousel controls
			parent.querySelectorAll('.next-arrow').forEach(arrow => {
				arrow.addEventListener('click', () => handleCarouselChange(1));
			});

			parent.querySelectorAll('.prev-arrow').forEach(arrow => {
				arrow.addEventListener('click', () => handleCarouselChange(-1));
			});

		// Attach event listeners for dots
			parent.querySelectorAll('.dot').forEach((dot, index) => {
				dot.addEventListener('click', () => handleDotClick(index));
			});

			// Attach event listeners for image clicks to open dialog
			parent.querySelectorAll('.galeria-karuzela-block .gallery-image').forEach(image => image.addEventListener('click', (event) => {
				const targetImage = image.querySelector('img');
				if (targetImage) {
					openDialog(targetImage.src);
				}
			}));

			//Click outside close dialog
			document.getElementById('gallery-dialog').addEventListener('click', (event) => {
				closeDialog();
			})

			window.addEventListener('resize', updateCarousel);
	}

	// Initialize the carousel on page load
	(async () => {
		try {
			updateCarousel();
			attachEvents();
		} catch(e) {}
	})();
});
